import React from "react";
import { Link } from "react-router-dom";
import "./Error404.css";

function Error404() {
  return (
    <div className="error-page">
      <div className="error-content">
        <div className="glitch-wrapper">
          <div className="glitch" data-text="404">
            404
          </div>
        </div>
        <h2 className="error-title">Страница не найдена</h2>
        <p className="error-description">
          Похоже, вы заблудились в цифровом пространстве. Страница, которую вы
          ищете, не существует или была перемещена.
        </p>
        <Link to="/home" className="error-button">
          <span>Вернуться домой</span>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
          </svg>
        </Link>

        <div className="floating-elements">
          <div className="float-element"></div>
          <div className="float-element"></div>
          <div className="float-element"></div>
          <div className="float-element"></div>
          <div className="float-element"></div>
        </div>
      </div>
    </div>
  );
}

export default Error404;
